<template>
  <FormGroupSelect
    required
    :field="field"
    :items="acblist"
    :label="label"
    :value="value.name"
    @change="change"
  >ACB</FormGroupSelect>
</template>

<script>
import { useFind } from 'feathers-vuex'
import { computed } from '@vue/composition-api'
import FormGroupSelect from '@/components/UI/forms/form-group/select'

export default {
  props: {
    value: {
      type: Object,
      default() { return {} }
    },
    field: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  components: {
    FormGroupSelect
  },
  setup(props, context) {
    const { ACB } = context.root.$FeathersVuex.api
    const { emit } = context

    const change = ({ field, value }) => {
      const acb = items.value.find(i => i.name === value)
      emit('change', { field, value:acb })
    }

    const params = computed(() => {
      return {
        query: {
          enabled: true,
          $select: ['_id', 'name', 'enabled'],
          $sort: { name: 1 },
          $limit: 99
        },
      }
    })

    const { items } = useFind({
      model: ACB,
      params
    })

    const acblist = computed(() => {
      return items.value.map(i => i.name)
    })

    return {
      change,
      acblist
    }
  }

}
</script>
